import { PDFDocument } from 'pdf-lib';

/**
 * Puts PDFs one after the other as one PDF
 * @param pdfs The PDFs, in the order that they are to be in
 */
export const mergePdfs = async (pdfs : Blob[]) : Promise<Blob> => {

    const merged = await PDFDocument.create();

    for (const pdf of pdfs) {
        const source = await PDFDocument.load(await readBytes(pdf));
        const pages = await merged.copyPages(source, source.getPageIndices());
        pages.forEach(page => merged.addPage(page));
    }

    return new Blob([await merged.save()], { type: 'application/pdf' });
};

const readBytes = (blob : Blob) : Promise<ArrayBuffer> => {

    if (blob.arrayBuffer) {
        return blob.arrayBuffer();
    }

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as ArrayBuffer);
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(blob);
    });
};
